import React from "react";

import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableContainer,
  makeStyles,
} from "@material-ui/core";

import { DEFAULT_WORKING_HOURS } from "./constants";
import { DayHours, DayHoursSkeleton, TableHeader } from "./components";
import { MyWorkingHoursProps } from "./types";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
  },
  cardContent: {
    padding: 0,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  row: {
    height: 72,
  },
}));

const MyWorkingHours: React.FC<MyWorkingHoursProps> = ({
  workingHours = DEFAULT_WORKING_HOURS,
  handleSliderChange,
  handleSelectAllClick,
  handleSelectClick,
  loading = false,
  disabled = false,
}) => {
  const classes = useStyles();
  const days = Object.entries(workingHours);

  const selected = days.reduce((acc: string[], [day, value]) => {
    if (value) {
      acc.push(day);
    }
    return acc;
  }, []);

  return (
    <Card data-test="working-hours">
      <CardHeader
        titleTypographyProps={{ component: "h3", variant: "h3" }}
        title="My working hours"
        data-test="my-working-hours-card-title"
      />
      <Divider />
      <CardContent className={classes.cardContent}>
        <TableContainer>
          <Table
            aria-labelledby="tableTitle"
            aria-label="My working hours table"
          >
            <TableHeader
              numSelected={selected.length}
              onSelectAllClick={handleSelectAllClick}
              rowCount={days.length}
              disabled={disabled || loading}
            />
            <TableBody>
              {days.map(([day, hours]) =>
                loading ? (
                  <DayHoursSkeleton key={day} />
                ) : (
                  <DayHours
                    key={day}
                    day={day}
                    hours={hours ? [hours.from, hours.to] : null}
                    handleSliderChange={(value: number[]) =>
                      handleSliderChange(day, value)
                    }
                    toggleAvailability={() => handleSelectClick(day)}
                    disabled={disabled}
                  />
                ),
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default MyWorkingHours;
